import React, {useState} from 'react';
import {AuthZTable, defaultPageSize, defaultPageSizeOptions} from "../../../components/authZTable";
import {ColumnSelectPaginationPortal} from "../../../components/authZTable/column-select-pagination-portal";
import {PolicyListController} from "./controller";
import {allPoliciesTable} from "./model";
import {LinkSpan} from "../../../components/linkSpan";
import {CloseOutlined, EditFilled} from "@ant-design/icons";
import "../index.css";
import {SystemResource} from "../../information-assets/models/system-resources";
import {sendUserEvent, UserAction} from "../../../components/matomoClient";
import {Group} from "./models/Group";
import {Routes} from "../../../common/Routes";
import {useHistory} from "react-router-dom";
import { Tooltip } from 'antd';

const PolicyList = () => {
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(defaultPageSize);
    const [searchFilter, setSearchFilter] = useState({});
    const [userQuery, setUserQuery] = useState({});
    const [sorter, setSorter] = useState({});

    const history = useHistory();

    const {
        data,
        totalCount,
        isLoading,
    } = PolicyListController(page, size, userQuery, sorter);

    const editPolicy = (id) => {
        return () => history.push(
          `/policies/edit/${id}`,
        );
      }

    const columns = [
        {
            title: "Policy name",
            dataIndex: "name",
            key: "name",
            render: "",
            tableFilter: null,
            className: "",
            isFilterable: true,
            identifier: null,
            width: 200,
        },
        {
            title: "Policy ID",
            dataIndex: "id",
            key: "id",
            render: "",
            tableFilter: null,
            className: "",
            isFilterable: true,
            identifier: null,
            width: 150,
            sortEnabled: false,
        },
        {
            title: "Business Team",
            dataIndex: "group",
            key: "group",
            render: (item: Group) => {
                return <>
                    {item.uniqueName !== undefined ? <LinkSpan
                            text={item.name} to={`${Routes.UserGroups.basePath}/business-team/${item.uniqueName}`}
                            keyId={undefined} className={undefined}
                            target={undefined} active={undefined}
                            matomoFn={() => {
                                sendUserEvent(UserAction.UserGroupDetails);
                            }}
                                                     />
                        :
                        <div>{item.name}</div>}
                       </>
            },
            tableFilter: null,
            className: "",
            isFilterable: true,
            identifier: null,
            width: 200
        },
        {
            title: "Scope",
            dataIndex: "scope",
            key: "scope",
            render: "",
            tableFilter: null,
            className: "",
            isFilterable: true,
            identifier: null,
            width: 150
        },
        {
            title: "Access type",
            dataIndex: "actions",
            key: "actions",
            tableFilter: null,
            className: "",
            isFilterable: true,
            identifier: null,
            width: 200,
            render: (items) => {
                return (
                    <div>
                        {items.map((item, index) => (
                            <div className={"multiTable"} key={index}>{item}</div>
                        ))}
                    </div>
                );
            },
        },
        {
            title: "System Resource",
            dataIndex: "systemResource",
            key: "systemResource",
            tableFilter: null,
            className: "",
            isFilterable: true,
            identifier: null,
            width: 200,
            render: (systemResources: SystemResource[]) => {
                return (<div>
                        {systemResources.map((item: SystemResource, index) => (
                            <div className={"multiTable"} key={index}>{item.name}</div>
                        ))}
                        </div>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "actions",
            key: "actions",
            render: (_text, record) => {
                return <>
                    <Tooltip title="Edit">
                        <EditFilled style={{marginRight: "15px", fontSize: "15px"}} onClick={editPolicy(record.id)}/>
                    </Tooltip>
                    <CloseOutlined style={{fontSize: "15px"}}/>
                       </>
            },
            tableFilter: null,
            className: "",
            isFilterable: false,
            identifier: null,
            width: 200,
            searchEnabled: false,
            sortEnabled: false
        }
    ]

    const onPageChange = (current: React.SetStateAction<number>) => {
        setPage(current);
    };

    const changePageSize = (size: React.SetStateAction<number>, current: any) => {
        setSize(size);
    };

    function onChange(filters, sorter) {
        if (filters) {
            const id = filters.id != null ? filters.id[0] : "";
            const name = filters.name != null ? filters.name[0] : "";
            const group = filters.group != null ? filters.group[0] : "";
            const scope = filters.scope != null ? filters.scope[0] : "";
            const actions = filters.actions != null ? filters.actions[0] : "";
            const systemResource = filters.systemResource != null ? filters.systemResource[0] : "";
            setUserQuery({
                ...userQuery,
                name: name,
                id: id,
                group: group,
                scope: scope,
                actions: actions,
                systemResource: systemResource,
            });
        }

        if (sorter?.columnKey) {
            const sortColumnKey = (sorter?.order) ? sorter.columnKey : null;

            setSorter({
                sortField: sortColumnKey,
                sortDirection: sorter?.order,
            });
        }
    }

    function onCustomFilterAndCustomSortChange(filters, sorter) {
        const updatedFilters = {
            ...searchFilter,
            ...filters,
        };
        onChange(updatedFilters, sorter);
        setSearchFilter(updatedFilters);
    }

    function onFilterChange(pagination, filters, sorter) {
        if (pagination === null) setPage(1);
        const updatedFilters = {
            ...searchFilter,
            ...filters,
        };
        onChange(updatedFilters, sorter);
        setSearchFilter(updatedFilters);
    }


    return (
        <div style={{marginTop: "1rem"}}>
            <AuthZTable
                id={allPoliciesTable.id}
                rowKey={"key"}
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSize: size,
                    pageSizeOptions: defaultPageSizeOptions,
                    showTotal: (total: any, range: any[]) => `${range[0]}-${range[1]} of ${total} items`,
                    current: page,
                    total: totalCount,
                    onShowSizeChange: (current: any, pageSize: React.SetStateAction<number>) => changePageSize(pageSize, current),
                    onChange: (current) => onPageChange(current),
                }}
                scroll={{x: "max-content", y: "calc(100vh - 430px)"}}
                onChange={onFilterChange}
                onCustomFilterAndCustomSortChange={onCustomFilterAndCustomSortChange}
                isFilteredOrSortedInBackend={true}
            />
            <ColumnSelectPaginationPortal id={allPoliciesTable.id}>
            </ColumnSelectPaginationPortal>
        </div>
    );
};

export default PolicyList;